export const PRACTICE_BUILDER_CRUD_KEY = 'jbp-key-initiative-practice-builder'
export const PRACTICE_BUILDER_PAGE_SIZE = 100

export const STRATEGIC_INITIATIVE_TO_BUSINESS_UNIT_MAPPING: Record<string, string[]> = {
  iMPS: ['iMPS', 'Print', 'Print/iMPS', 'Print/Supplies/iMPS'],
  ACS: ['PC', 'PC/PS Service', 'Workstation'],
  'Poly VideoVoice': ['Poly', 'Poly/HyperX'],
  HPS: ['PC/PS Service', 'PS Services'],
}
